if (!(/** @type {any} */ (window).__lengthSoftNavInit)) {
  /** @type {any} */ (window).__lengthSoftNavInit = true;

  const getPageSections = () => {
    const sectionIds = [];
    const mainSection = document.querySelector('[id^="shopify-section-"][id*="__main"], #shopify-section-main');
    sectionIds.push(mainSection ? mainSection.id.replace('shopify-section-', '') : 'main');
    const recommendationsSection = document.querySelector('[id^="shopify-section-"][id*="recommendations"]');
    if (recommendationsSection) sectionIds.push(recommendationsSection.id.replace('shopify-section-', ''));
    return sectionIds;
  };

  /** @param {string} sectionId @param {Document} parsedDocument */
  const updateSection = (sectionId, parsedDocument) => {
    const sectionElement =
      document.querySelector(`#shopify-section-${sectionId}`) ||
      document.querySelector(`[id^="shopify-section-"][id$="__${sectionId}"]`);
    if (!sectionElement) return;
    const newContent = parsedDocument.querySelector('.shopify-section') || parsedDocument.body.firstElementChild;
    if (!newContent) return;
    const originalId = sectionElement.id;
    const originalClassName = sectionElement.className;
    sectionElement.innerHTML = newContent.innerHTML;
    sectionElement.id = originalId;
    sectionElement.className = originalClassName;
    for (const scriptElement of sectionElement.querySelectorAll('script[src]')) {
      const newScript = document.createElement('script');
      newScript.type = /** @type {HTMLScriptElement} */ (scriptElement).type || 'module';
      newScript.src = /** @type {HTMLScriptElement} */ (scriptElement).src;
      scriptElement.replaceWith(newScript);
    }
    sectionElement.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
  };

  /** @type {AbortController | null} */
  let abortController = null;

  /** @param {string} targetUrl */
  const softNavigate = async (targetUrl) => {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    const mainSectionElement = document.querySelector('#shopify-section-main');
    if (mainSectionElement) {
      mainSectionElement.classList.add('is-loading');
      mainSectionElement.setAttribute('aria-busy', 'true');
    }

    try {
      const baseUrl = targetUrl.split('?')[0];
      const sectionIdsParam = getPageSections().join(',');
      const response = await fetch(`${baseUrl}?sections=${sectionIdsParam}`, {
        credentials: 'same-origin',
        signal: abortController.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const sectionsData = await response.json();

      const parsedSections = Object.entries(sectionsData)
        .filter(([, htmlContent]) => htmlContent && typeof htmlContent === 'string')
        .map(([sectionId, htmlContent]) => ({
          sectionId,
          parsedDocument: new DOMParser().parseFromString(/** @type {string} */ (htmlContent), 'text/html'),
        }));

      const scrollPosition = window.scrollY;

      const applyUpdates = () => {
        for (const { sectionId, parsedDocument } of parsedSections) updateSection(sectionId, parsedDocument);
        const pageHeading = parsedSections[0]?.parsedDocument.querySelector('h1');
        if (pageHeading) document.title = `${pageHeading.textContent?.trim() ?? ''} – ${window.Shopify?.shop ?? ''}`;
      };

      if (typeof document.startViewTransition === 'function') {
        await document.startViewTransition(applyUpdates).finished;
      } else {
        applyUpdates();
      }

      window.scrollTo(0, scrollPosition);
      history.pushState({ softNav: true }, '', targetUrl);
    } catch (error) {
      if (/** @type {Error} */ (error).name === 'AbortError') return;
      window.location.href = targetUrl;
    } finally {
      abortController = null;
      if (mainSectionElement) {
        mainSectionElement.classList.remove('is-loading');
        mainSectionElement.setAttribute('aria-busy', 'false');
      }
    }
  };

  document.addEventListener('click', (event) => {
    const navigationLink = /** @type {HTMLElement | null} */ (event.target)?.closest(
      'a[data-length-navigate], a[data-gear-set-navigate]',
    );
    if (!navigationLink) return;
    event.preventDefault();
    event.stopPropagation();
    softNavigate(/** @type {HTMLAnchorElement} */ (navigationLink).href);
  });

  window.addEventListener('popstate', async (event) => {
    if (!event.state?.softNav) return;
    if (abortController) abortController.abort();
    abortController = new AbortController();
    const mainSectionElement = document.querySelector('#shopify-section-main');
    if (mainSectionElement) {
      mainSectionElement.classList.add('is-loading');
      mainSectionElement.setAttribute('aria-busy', 'true');
    }
    try {
      const baseUrl = document.location.href.split('?')[0];
      const sectionIdsParam = getPageSections().join(',');
      const response = await fetch(`${baseUrl}?sections=${sectionIdsParam}`, {
        credentials: 'same-origin',
        signal: abortController.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const sectionsData = await response.json();
      const scrollPosition = window.scrollY;
      for (const [sectionId, htmlContent] of Object.entries(sectionsData)) {
        if (htmlContent && typeof htmlContent === 'string') {
          updateSection(sectionId, new DOMParser().parseFromString(htmlContent, 'text/html'));
        }
      }
      window.scrollTo(0, scrollPosition);
    } catch (error) {
      if (/** @type {Error} */ (error).name !== 'AbortError') window.location.href = document.location.href;
    } finally {
      abortController = null;
      if (mainSectionElement) {
        mainSectionElement.classList.remove('is-loading');
        mainSectionElement.setAttribute('aria-busy', 'false');
      }
    }
  });
}
